import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { connect, useDispatch } from 'react-redux';
import { LazyLoadImage } from 'react-lazy-load-image-component';

// Import Actions
import { actions as WishlistAction } from '../../../store/wishlist';
import { actions as CartAction } from '../../../store/cart/actions';
import { actions as ModalAction } from '../../../store/modal';

// Import Custom Component
import ALink from '../../common/ALink';

// Import Utils
import { productCountDown } from '../../../utils';
import CountDown from '../../features/countdown';
import { sections } from '../../../utils/data/shop';
import { setCategory } from '../../../store/categories';
import PlaceholderImage from '../../common/PlaceholderImage';

function ProductHomeCard(props) {
  const router = useRouter();
  const query = router.query;
  const { adClass = '', link = 'default', product, manualUrlRedirect } = props;
  const routeGeneralCheck = router.pathname === '/';
  const dispatch = useDispatch();
  useEffect(() => {
    productCountDown();
  });

  const [isDisabled, setIsDisabled] = useState(false);

  function isSale() {
    return product.price[0] !== product.price[1]
      ? '-' +
          (
            (100 * (product.price[1] - product.price[0])) /
            product.price[1]
          ).toFixed(0) +
          '%'
      : product.variants.find(variant => variant.sale_price)
      ? 'Sale'
      : false;
  }

  function isInWishlist() {
    return (
      product &&
      props.wishlist.findIndex(item => item.slug === product.slug) > -1
    );
  }

  function onWishlistClick(e) {
    e.preventDefault();
    if (!isInWishlist()) {
      let target = e.currentTarget;
      target.classList.add('load-more-overlay');
      target.classList.add('loading');

      setTimeout(() => {
        target.classList.remove('load-more-overlay');
        target.classList.remove('loading');
        props.addToWishList(product);
      }, 1000);
    } else {
      router.push('/wishlist');
    }
  }

  function onAddCartClick(e) {
    e.preventDefault();
    setIsDisabled(true);
    props.addToCart(product);
    setTimeout(() => {
      setIsDisabled(false);
    }, 1000);
  }

  function onQuickViewClick(e) {
    e.preventDefault();
    props.showQuickView(product.slug);
  }

  return (
    <div
      className={`product-default inner-quickview inner-icon media-with-lazy ${adClass} product-custom-card`}>
      <figure>
        <ALink
          href={
            manualUrlRedirect
              ? manualUrlRedirect 
              : `/product/${link}${product.slug}`
          }>

          <PlaceholderImage
            alt="Product"
            src={
              (!product?.pictures[0]?.url?.includes?.('https:')
                ? process.env.NEXT_PUBLIC_ASSET_URI
                : '') + product.pictures[0]?.url
            }
            width="100%"
            height="100%"
          />
          {/*{product.pictures.length >= 2 ? (*/}
          {/*  <Image*/}
          {/*    alt="product"*/}
          {/*    src={*/}
          {/*      (!product?.pictures[0]?.url?.includes?.('https:')*/}
          {/*        ? process.env.NEXT_PUBLIC_ASSET_URI*/}
          {/*        : '') + product.pictures[1]?.url*/}
          {/*    }*/}
          {/*    width={340}*/}
          {/*    height={340}*/}
          {/*    loading="lazy"*/}
          {/*  />*/}
          {/*) : (*/}
          {/*  // <LazyLoadImage*/}
          {/*  //   alt="product"*/}
          {/*  //   src={*/}
          {/*  //     (!product?.pictures[0]?.url?.includes?.('https:')*/}
          {/*  //       ? process.env.NEXT_PUBLIC_ASSET_URI*/}
          {/*  //       : '') + product.pictures[1].url*/}
          {/*  //   }*/}
          {/*  //   threshold={500}*/}
          {/*  //   effect="black and white"*/}
          {/*  //   wrapperClassName="product-image-hover"*/}
          {/*  // />*/}
          {/*  ''*/}
          {/*)}*/}
        </ALink>

        <div className="label-group">
          {product.is_hot ? (
            <div className="product-label label-hot">HOT</div>
          ) : (
            ''
          )}

          {isSale() ? (
            <div className="product-label label-sale">{isSale()}</div>
          ) : (
            ''
          )}
        </div>

        {!routeGeneralCheck && (
          <div className="btn-icon-group">
            {product.variants.length > 0 ? (
              <ALink
                // href={`/product/default/${product.slug}`}
                href="#"
                onClick={onQuickViewClick}
                className="btn-icon btn-add-cart">
                <i className="fa fa-arrow-right"></i>
              </ALink>
            ) : (
              <a
                href="#"
                className="btn-icon btn-add-cart product-type-simple"
                title="Quick view"
                onClick={onQuickViewClick}>
                {/*<i className="icon-shopping-cart"></i>*/}
                <i className="fa fa-arrow-right"></i>
              </a>
            )}
          </div>
        )}

        {!!product.until && <CountDown product={product} />}

        {!routeGeneralCheck && (
          <button
            className="btn-quickview"
            onClick={onAddCartClick}
            disabled={isDisabled}>
            ADD TO CART
          </button>
        )}
      </figure>

      <div className="product-details">
        <div className="category-wrap">
          <div className="category-list">
            {product.categories
              ? product.categories.slice(0, 2).map((item, index) => (
                  <React.Fragment key={item.slug + '-' + index}>
                    <ALink
                      onClick={() => {
                        dispatch(setCategory(item));
                      }}
                      href={{
                        pathname: '/shop',
                        // query: { category: item.slug }
                        query: {
                          ...query,
                          filters: JSON.stringify({
                            [sections.categories]: [item.name],
                            [sections.price]: { min: 0, max: 0 },
                            [sections.materials]: [],
                            [sections.colors]: []
                          }),
                          page: 1,
                        }
                      }}>
                      {item.name}
                    </ALink>
                    {index < product.categories.slice(0, 2).length - 1 ? ', ' : ''}
                  </React.Fragment>
                ))
              : ''}
          </div>

          <a
            href="#"
            className={`btn-icon-wish ${
              isInWishlist() ? 'added-wishlist' : ''
            }`}
            onClick={onWishlistClick}
            title={`${isInWishlist() ? 'Go to Wishlist' : 'Add to Wishlist'}`}>
            {/*<i className="icon-heart"></i>*/}
          </a>
        </div>

        <h3 className="product-title product-home-title">
          <ALink href={`/product/default${product.slug}`}>{product.name}</ALink>
        </h3>

        <div className="price-box price-box-home">
          {product?.sale_end?.sale_in_seconds > 0 ? (
            <>
              <span className="product-price product-home-price">
                {'$' + product?.price[0]?.toFixed(2)}
              </span>
              <span className="old-price product-home-old-price">
                {'$' + product?.price[1]?.toFixed(2)}
              </span>
              <div className="product-home-sale">
                <LazyLoadImage width={11} src="/images/fire.svg" alt="Hot Sale" />
                <span className="product-home-sale-text">
                  Sale Ends in:
                  <span className="product-home-sale-text-lower">
                    {/* need field 'promotionTo' & 'promotionFrom' from BE */}
                    <span className="product-home-sale-text-bold">
                      {product.sale_end.days}
                    </span>
                    d{' '}
                    <span className="product-home-sale-text-bold">
                      {product.sale_end.hours}
                    </span>
                    h{' '}
                    <span className="product-home-sale-text-bold">
                      {product.sale_end.minutes}
                    </span>
                    m{' '}
                  </span>
                </span>
              </div>
            </>
          ) : (
            <span className="product-price product-home-price">
              {'$' + product?.price[0]?.toFixed(2)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    wishlist: state.wishlist.list ? state.wishlist.list : []
  };
};

export default connect(mapStateToProps, {
  ...WishlistAction,
  ...CartAction,
  ...ModalAction
})(React.memo(ProductHomeCard));
